var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path10, _path11, _g6, _path12, _path13, _g7, _path14, _path15, _g8, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeedtest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 109,
    viewBox: "0 0 181 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_3292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 39,
    width: 80,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.814 39.7698C165.122 54.483 173.938 74.5658 173.938 96.7096H95.0276L94.4512 96.1331L150.814 39.7698Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.814 39.7698C165.122 54.483 173.938 74.5658 173.938 96.7096H95.0276L94.4512 96.1331L150.814 39.7698Z",
    fill: "url(#paint0_linear_9_3292)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2051 96.2815H173.509C173.4 75.3129 165.352 55.493 150.809 40.3808L95.0561 96.1333L95.2051 96.2815ZM173.938 97.1381H95.0278C94.9139 97.1381 94.8051 97.0927 94.7255 97.0121L94.1481 96.4365C94.0676 96.356 94.0222 96.2472 94.0222 96.1333C94.0222 96.0194 94.0676 95.9106 94.1481 95.831L150.511 39.4677C150.592 39.3872 150.701 39.3418 150.815 39.3418H150.818C150.933 39.3426 151.042 39.3897 151.121 39.472C166.111 54.8857 174.367 75.2127 174.367 96.7098C174.367 96.9462 174.175 97.1381 173.938 97.1381Z",
    fill: "#0B4582"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9_3292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 63,
    width: 48,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.512 63.3107C135.904 71.9405 141.075 83.7207 141.075 96.7096H94.7887L94.4512 96.3713L127.512 63.3107Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.512 63.3107C135.904 71.9405 141.075 83.7207 141.075 96.7096H94.7887L94.4512 96.3713L127.512 63.3107Z",
    fill: "url(#paint1_linear_9_3292)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1469 96.2815H140.646C140.539 84.1535 135.886 72.6936 127.506 63.9224L95.1469 96.2815ZM141.076 97.1381H94.7897C94.6758 97.1381 94.567 97.0927 94.4865 97.0121L94.1481 96.6747C94.0676 96.595 94.0222 96.4854 94.0222 96.3714C94.0222 96.2584 94.0676 96.1496 94.1481 96.0691L127.209 63.0076C127.289 62.928 127.398 62.8826 127.512 62.8826C127.592 62.8903 127.739 62.9288 127.819 63.0119C136.645 72.0863 141.505 84.0541 141.505 96.7098C141.505 96.9462 141.313 97.1381 141.076 97.1381Z",
    fill: "#0B4582"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9_3292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 15,
    width: 37,
    height: 77
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2702 91.3477L56.3968 57.4742C57.8469 53.0055 58.6238 48.2944 58.6761 43.4626C58.7463 36.8465 57.4512 30.4249 54.9192 24.5206C65.7666 18.905 77.8219 15.7812 90.2702 15.4822V91.3477Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2702 91.3477L56.3968 57.4742C57.8469 53.0055 58.6238 48.2944 58.6761 43.4626C58.7463 36.8465 57.4512 30.4249 54.9192 24.5206C65.7666 18.905 77.8219 15.7812 90.2702 15.4822V91.3477Z",
    fill: "url(#paint2_linear_9_3292)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.511 37.5875L90.2703 91.3477V15.4823C70.1857 15.9636 51.1282 23.8003 36.511 37.5875ZM90.6986 92.8098C90.5873 92.8098 90.4785 92.7661 90.3962 92.6848L35.5936 37.8821C35.5122 37.8008 35.4668 37.6903 35.4686 37.5746C35.4694 37.459 35.5174 37.3494 35.6013 37.2697C50.5209 23.0457 70.0855 15.0009 90.6909 14.6163C90.8382 14.618 90.917 14.6583 90.9993 14.7388C91.0815 14.8201 91.1269 14.9298 91.1269 15.0446V92.3815C91.1269 92.5546 91.0224 92.7113 90.8631 92.7773L90.6986 92.8098Z",
    fill: "#0B4582"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9_3292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 48,
    width: 32,
    height: 45
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.28 60.9619C67.4833 53.1407 78.5235 48.2694 90.6995 48.0424V92.3813L59.28 60.9619Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.28 60.9619C67.4833 53.1407 78.5235 48.2694 90.6995 48.0424V92.3813L59.28 60.9619Z",
    fill: "url(#paint3_linear_9_3292)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.894 60.9707L90.2702 91.3477V48.4803C78.9328 48.7981 68.177 53.2205 59.894 60.9707ZM90.6985 92.8098C90.5871 92.8098 90.4783 92.7661 90.3961 92.6848L58.9767 61.2653C58.8953 61.1831 58.8499 61.0726 58.8516 60.957C58.8525 60.8413 58.9004 60.7317 58.9835 60.652C67.5705 52.4659 78.8308 47.8354 90.6908 47.6144C90.8381 47.6032 90.9169 47.6555 90.9991 47.7368C91.0814 47.8174 91.1268 47.927 91.1268 48.0426V92.3815C91.1268 92.5546 91.0222 92.7113 90.8629 92.7773L90.6985 92.8098Z",
    fill: "#0B4582"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9_3292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 15,
    width: 56,
    height: 78
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8071 15.0444C115.044 15.441 134.3 23.9372 148.61 37.5796L93.8071 92.3813V15.0444Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.8071 15.0444C115.044 15.441 134.3 23.9372 148.61 37.5796L93.8071 92.3813V15.0444Z",
    fill: "url(#paint4_linear_9_3292)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2352 15.4823V91.3477L147.995 37.5875C133.378 23.8003 114.32 15.9636 94.2352 15.4823ZM93.8069 92.8098L93.6433 92.7773C93.4832 92.7113 93.3787 92.5546 93.3787 92.3815V15.0446C93.3787 14.9298 93.4249 14.8193 93.5071 14.7388C93.5885 14.6583 93.6613 14.6146 93.8155 14.6163C114.421 15.0009 133.986 23.0457 148.904 37.2697C148.988 37.3494 149.036 37.459 149.038 37.5746C149.04 37.6903 148.994 37.8008 148.912 37.8821L94.1102 92.6848C94.0279 92.7661 93.9183 92.8098 93.8069 92.8098Z",
    fill: "#0B4582"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9_3292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 48,
    width: 32,
    height: 45
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8071 48.6412C105.819 48.8656 116.709 53.6709 124.803 61.3859L93.8071 92.3813V48.6412Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.8071 48.6412C105.819 48.8656 116.709 53.6709 124.803 61.3859L93.8071 92.3813V48.6412Z",
    fill: "url(#paint5_linear_9_3292)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2352 49.0799V91.3477L124.187 61.3955C116.02 53.755 105.415 49.3943 94.2352 49.0799ZM93.8069 92.8098L93.6433 92.7773C93.4832 92.7113 93.3787 92.5546 93.3787 92.3815V48.6414C93.3787 48.5266 93.4249 48.4161 93.5071 48.3356C93.5885 48.2551 93.6613 48.2114 93.8155 48.2131C105.517 48.4315 116.627 52.9995 125.098 61.0769C125.181 61.1565 125.229 61.2662 125.231 61.3818C125.232 61.4975 125.187 61.608 125.105 61.6893L94.1102 92.6848C94.0279 92.7661 93.9183 92.8098 93.8069 92.8098Z",
    fill: "#0B4582"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9_3292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 61,
    width: 80,
    height: 36
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3014 96.2814H10.9973C11.0093 94.098 11.1061 91.9283 11.2877 89.7741C11.3143 89.775 11.3391 89.775 11.3656 89.775C11.537 89.7767 11.7074 89.7775 11.8787 89.7775C24.1909 89.7775 35.799 85.0442 44.6121 76.4178C49.0277 72.0947 52.4805 67.0504 54.8608 61.5445L89.4495 96.1332L89.3014 96.2814Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3014 96.2814H10.9973C11.0093 94.098 11.1061 91.9283 11.2877 89.7741C11.3143 89.775 11.3391 89.775 11.3656 89.775C11.537 89.7767 11.7074 89.7775 11.8787 89.7775C24.1909 89.7775 35.799 85.0442 44.6121 76.4178C49.0277 72.0947 52.4805 67.0504 54.8608 61.5445L89.4495 96.1332L89.3014 96.2814Z",
    fill: "url(#paint6_linear_9_3292)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.997 96.2815H89.3011L89.4493 96.1333L33.6967 40.3808C19.1541 55.493 11.105 75.3129 10.997 96.2815ZM89.4792 97.1381H10.5679C10.3315 97.1381 10.1396 96.9462 10.1396 96.7098C10.1396 75.2127 18.3952 54.8857 33.3849 39.472C33.4646 39.3889 33.5391 39.3203 33.6916 39.3418C33.8047 39.3418 33.9143 39.3871 33.9948 39.4677L90.3581 95.831C90.4386 95.9106 90.4831 96.0194 90.4831 96.1333C90.4831 96.2472 90.4386 96.356 90.3581 96.4365L89.7816 97.0121C89.7011 97.0927 89.5923 97.1381 89.4792 97.1381Z",
    fill: "#0B4582"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_9_3292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 63,
    width: 48,
    height: 34
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7166 96.7096H43.4299C43.4299 83.7207 48.601 71.9405 56.9944 63.3107L90.055 96.3713L89.7166 96.7096Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_9_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7166 96.7096H43.4299C43.4299 83.7207 48.601 71.9405 56.9944 63.3107L90.055 96.3713L89.7166 96.7096Z",
    fill: "url(#paint7_linear_9_3292)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8611 96.2815H89.3598L56.9998 63.9224C48.621 72.6944 43.9673 84.1535 43.8611 96.2815ZM89.7178 97.1381H43.4302C43.1938 97.1381 43.002 96.9462 43.002 96.7098C43.002 84.055 47.8629 72.0872 56.6872 63.0119C56.7677 62.9297 56.8585 62.8706 56.9947 62.8826C57.1086 62.8826 57.2165 62.928 57.2971 63.0076L90.3585 96.0691C90.5255 96.2361 90.5255 96.5076 90.3585 96.6747L90.0202 97.0121C89.9405 97.0927 89.8317 97.1381 89.7178 97.1381Z",
    fill: "#0B4582"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.031 48.1764L100.166 94.123H82.2944L110.009 47.7541C110.343 47.2153 111.175 47.5588 111.031 48.1764Z",
    fill: "#0B4582"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8265 93.6947H83.049L110.377 47.9742C110.388 47.9562 110.432 47.8842 110.536 47.9271C110.638 47.9699 110.621 48.0504 110.614 48.0778L99.8265 93.6947ZM82.2953 94.5513H100.166C100.364 94.5513 100.537 94.4151 100.582 94.2223L111.447 48.2757L111.448 48.274C111.56 47.7926 111.32 47.3249 110.863 47.1356C110.404 46.9472 109.905 47.109 109.645 47.5288L81.9278 93.9037C81.8482 94.0365 81.8464 94.2001 81.9227 94.3354C81.9989 94.469 82.1411 94.5513 82.2953 94.5513Z",
    fill: "#0B4582"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.518 96.4141C106.518 96.5401 77.9883 96.5341 77.9883 96.4141C77.9883 88.5364 84.3748 82.1499 92.2534 82.1499C100.131 82.1499 106.518 88.5364 106.518 96.4141Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4229 96.0125C81.5579 96.1016 102.962 96.1008 106.084 96.0125C105.871 88.5682 99.7486 82.5783 92.2537 82.5783C84.7588 82.5783 78.6361 88.5682 78.4229 96.0125ZM92.5449 96.9351C88.9294 96.9351 85.2899 96.9273 82.554 96.9111C77.5603 96.8837 77.5603 96.8837 77.5603 96.4143C77.5603 88.3129 84.1524 81.7217 92.2537 81.7217C100.355 81.7217 106.946 88.3129 106.946 96.4143C106.946 96.8845 106.946 96.8845 102.172 96.9119C99.5567 96.9273 96.062 96.9351 92.5449 96.9351Z",
    fill: "#0B4582"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0604 94.9435H85.4463C85.4463 91.184 88.4939 88.1364 92.2534 88.1364C96.0128 88.1364 99.0604 91.184 99.0604 94.9435Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8877 94.5331C87.8758 94.5691 96.6358 94.5691 98.6188 94.534C98.4072 91.2063 95.6328 88.5646 92.2537 88.5646C88.8737 88.5646 86.0993 91.2063 85.8877 94.5331ZM92.3642 95.4154C90.6425 95.4154 88.9122 95.412 87.6128 95.4051C85.0183 95.3897 85.0183 95.3897 85.0183 94.9434C85.0183 90.9536 88.2638 87.7081 92.2537 87.7081C96.2435 87.7081 99.489 90.9536 99.489 94.9434C99.489 95.4154 99.489 95.4154 92.3642 95.4154Z",
    fill: "#0B4582"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.34 101.686H1.83325V93.8059H179.34V101.686Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26134 101.259H178.912V94.2343H2.26134V101.259ZM179.34 102.115H1.83306C1.59665 102.115 1.40479 101.924 1.40479 101.687V93.806C1.40479 93.5696 1.59665 93.3777 1.83306 93.3777H179.34C179.577 93.3777 179.769 93.5696 179.769 93.806V101.687C179.769 101.924 179.577 102.115 179.34 102.115Z",
    fill: "#0B4582"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M179.34 108.42H1.83325V104.48H179.34V108.42Z",
    fill: "#0B4582"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26134 107.991H178.912V104.908H2.26134V107.991ZM179.34 108.848H1.83306C1.59665 108.848 1.40479 108.656 1.40479 108.42V104.48C1.40479 104.243 1.59665 104.051 1.83306 104.051H179.34C179.577 104.051 179.769 104.243 179.769 104.48V108.42C179.769 108.656 179.577 108.848 179.34 108.848Z",
    fill: "#0B4582"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2533 8.354C91.7796 8.354 91.3967 7.97027 91.3967 7.49745V0.856543C91.3967 0.382865 91.7796 -1.62125e-05 92.2533 -1.62125e-05C92.727 -1.62125e-05 93.1098 0.382865 93.1098 0.856543V7.49745C93.1098 7.97027 92.727 8.354 92.2533 8.354Z",
    fill: "#0B4582"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5838 34.7264C28.3645 34.7264 28.1461 34.6425 27.9782 34.4755L23.2825 29.7798C22.9485 29.4449 22.9485 28.9027 23.2825 28.5686C23.6174 28.2337 24.1596 28.2337 24.4937 28.5686L29.1894 33.2643C29.5243 33.5983 29.5243 34.1406 29.1894 34.4755C29.0223 34.6425 28.803 34.7264 28.5838 34.7264Z",
    fill: "#0B4582"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5838 34.7264C28.3645 34.7264 28.1461 34.6425 27.9782 34.4755L23.2825 29.7798C22.9485 29.4449 22.9485 28.9027 23.2825 28.5686C23.6174 28.2337 24.1596 28.2337 24.4937 28.5686L29.1894 33.2643C29.5243 33.5983 29.5243 34.1406 29.1894 34.4755C29.0223 34.6425 28.803 34.7264 28.5838 34.7264Z",
    fill: "#0B4582"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52582 67.9189C7.42988 67.9189 7.33138 67.9027 7.23544 67.8684L0.987709 65.6199C0.542299 65.4598 0.311025 64.9689 0.471202 64.5244C0.631378 64.079 1.12133 63.8503 1.56674 64.0079L7.81534 66.2564C8.26075 66.4165 8.49202 66.9065 8.33184 67.3519C8.20593 67.7014 7.87615 67.9189 7.52582 67.9189Z",
    fill: "#0B4582"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M173.715 60.0353C173.393 60.0353 173.086 59.8537 172.94 59.5436C172.739 59.1153 172.922 58.6057 173.35 58.4035L179.358 55.5743C179.787 55.3713 180.297 55.5563 180.498 55.9846C180.7 56.4129 180.516 56.9225 180.088 57.1247L174.079 59.9539C173.961 60.0096 173.838 60.0353 173.715 60.0353Z",
    fill: "#0B4582"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M155.923 34.7264C155.704 34.7264 155.484 34.6425 155.317 34.4755C154.982 34.1406 154.982 33.5983 155.317 33.2643L160.013 28.5686C160.348 28.2337 160.89 28.2337 161.224 28.5686C161.559 28.9027 161.559 29.4449 161.224 29.7798L156.529 34.4755C156.361 34.6425 156.142 34.7264 155.923 34.7264Z",
    fill: "#0B4582"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M126.997 15.3273C126.887 15.3273 126.775 15.3059 126.668 15.2605C126.231 15.078 126.025 14.5761 126.207 14.1401L128.77 8.01396C128.953 7.57626 129.455 7.37155 129.89 7.554C130.327 7.73645 130.532 8.23838 130.35 8.67436L127.788 14.8005C127.651 15.1294 127.332 15.3273 126.997 15.3273Z",
    fill: "#0B4582"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0827 15.0901C57.7452 15.0901 57.4257 14.8897 57.2895 14.5582L54.7703 8.41407C54.5905 7.97637 54.7995 7.47614 55.2372 7.29626C55.674 7.11638 56.1751 7.32624 56.355 7.76394L58.875 13.908C59.054 14.3457 58.845 14.846 58.4073 15.0258C58.3011 15.0687 58.1915 15.0901 58.0827 15.0901Z",
    fill: "#0B4582"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_3292",
    x1: 155.52,
    y1: 72.069,
    x2: 12.8854,
    y2: 151.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5050AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_3292",
    x1: 130.272,
    y1: 82.256,
    x2: 46.6073,
    y2: 128.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5050AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_3292",
    x1: 11.7734,
    y1: -25.212,
    x2: 127.499,
    y2: 90.5134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C5BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_3292",
    x1: 45.4492,
    y1: 24.9616,
    x2: 111.798,
    y2: 91.3102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C5BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_3292",
    x1: 157.651,
    y1: -31.5653,
    x2: 70.6038,
    y2: 106.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9_3292",
    x1: 129.916,
    y1: 22.2789,
    x2: 80.6837,
    y2: 100.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9_3292",
    x1: -45.8037,
    y1: 0.305659,
    x2: 70.0399,
    y2: 116.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C5BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9_3292",
    x1: 10.3642,
    y1: 40.1622,
    x2: 78.3146,
    y2: 108.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C5BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedtest);
export default __webpack_public_path__ + "static/media/speedtest.6aacfcd8654b268791ecfe09197029c7.svg";
export { ForwardRef as ReactComponent };